import { Component } from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'app-motto-card',
  templateUrl: './motto-card.component.html',
  styleUrls: ['./motto-card.component.scss'],
  imports: [
    TranslateModule,
  ],
  standalone: true
})
export class MottoCardComponent {}